import React from 'react';

import { regex } from '../../utils/regex/regex';
import {
  BaseProps,
  Link as LinkComponent,
  LinkTarget,
  LinkType,
} from '../Link/Link';

export const hooks = {
  useGetLink(link: string) {
    return React.useMemo(() => {
      if (link.includes(CONFIG.basePath)) {
        return link.replace(CONFIG.basePath, '');
      }
      return link;
    }, [link]);
  },
};

export type Props = BaseProps & {
  alwaysTargetBlank?: boolean;
  isTargetBlank?: boolean;
  to: string;
};

export const LocalizedLink = React.memo((props: Props) => {
  const {
    children,
    to,
    alwaysTargetBlank = false,
    isTargetBlank,
    ...rest
  } = props;

  const isExternalHref = regex.isExternalHref(to);

  const link = hooks.useGetLink(to);

  return (
    <LinkComponent
      to={link}
      type={isExternalHref ? LinkType.ExternalHref : LinkType.Href}
      target={isExternalHref || alwaysTargetBlank || isTargetBlank
        ? LinkTarget.Blank : LinkTarget.Self}
      {...rest}
    >
      {children}
    </LinkComponent>
  );
});

LocalizedLink.displayName = 'LocalizedLink';
